import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ABOUT } from "@/data/content";
import { Polaroid } from "@/components/Bits";

export default function About() {
  return (
    <div className="min-h-screen kitchen-bg pb-24" data-testid="about-page">
      <div className="max-w-3xl mx-auto px-4 pt-24">
        <Link to="/fridge" data-testid="back-to-fridge" className="font-hand font-bold text-ink/70 hover:text-ink text-lg">
          ← back to the fridge
        </Link>

        <motion.div
          className="relative mt-6 bg-[#FFF9C4] border-[4px] border-ink rounded-[6px] p-7 sm:p-10 shadow-[0_14px_0_rgba(43,35,32,0.15)] -rotate-[0.5deg]"
          initial={{ opacity: 0, y: 30, rotate: 2 }}
          animate={{ opacity: 1, y: 0, rotate: -0.5 }}
          transition={{ type: "spring", stiffness: 120, damping: 14 }}
        >
          {/* tape */}
          <div className="absolute -top-4 left-10 w-24 h-7 bg-[#FFE66D]/80 border-2 border-ink/40 -rotate-6" />
          <div className="absolute -top-3 right-12 w-20 h-7 bg-[#FFE66D]/80 border-2 border-ink/40 rotate-3" />

          <div className="flex flex-wrap items-start gap-6">
            <div className="flex-1 min-w-[240px]">
              <h1 className="font-display text-3xl sm:text-5xl leading-tight" data-testid="about-heading">{ABOUT.heading}</h1>
              <p className="font-hand text-lg text-ink/70 mt-2">{ABOUT.sub}</p>
            </div>
            <Polaroid label="me, probably hungry" className="w-32 aspect-[4/5] rotate-3" src={ABOUT.photo} />
          </div>

          <div className="grid sm:grid-cols-2 gap-4 mt-8">
            {ABOUT.sections.map((s, i) => (
              <motion.div
                key={i}
                className="paper border-[3px] border-ink rounded-xl p-4"
                style={{ rotate: i % 2 ? 0.8 : -0.8 }}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ delay: i * 0.06 }}
              >
                <p className="font-hand font-bold text-sm tracking-widest text-ink/55" style={{ textTransform: "uppercase" }}>{s.label}</p>
                {s.lines ? (
                  <ul className="mt-1.5 space-y-1.5">
                    {s.lines.map((l, j) => (
                      <li key={j} className="font-hand text-[15px] text-ink/85 leading-snug flex gap-2">
                        <span className="text-tomato font-bold flex-none">✦</span>
                        <span>{l}</span>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className="font-hand text-lg text-ink/85 mt-1 leading-snug">{s.text}</p>
                )}
              </motion.div>
            ))}
          </div>
        </motion.div>

        <p className="font-hand text-center mt-8 text-lg text-ink/80">
          psst — the grocery list on the door has my contact.{" "}
          <Link to="/contact" data-testid="about-link-to-contact" className="font-bold underline underline-offset-4">
            go check it →
          </Link>
        </p>
      </div>
    </div>
  );
}